import EventEmitter from 'eventemitter3';

import Dialog from 'src/interfaces/dialog';

const dialogEventEmitter = new EventEmitter();

const onAddDialog = (listener: (dialog: Dialog) => void) => {
  dialogEventEmitter.on('add-dialog', listener);
};

const offAddDialog = (listener: (dialog: Dialog) => void) => {
  dialogEventEmitter.off('add-dialog', listener);
};

const addDialog = (dialog: Dialog) => {
  dialogEventEmitter.emit('add-dialog', dialog);
};

const onPopById = (listener: (id: string) => void) => {
  dialogEventEmitter.on('pop-by-id', listener);
};

const offPopById = (listener: (id: string) => void) => {
  dialogEventEmitter.off('pop-by-id', listener);
};

const popById = (id: string) => {
  dialogEventEmitter.emit('pop-by-id', id);
};

const onCheckId = (listener: (payload: { id: string; res: boolean }) => void) => {
  dialogEventEmitter.on('check-id', listener);
};

const offCheckId = (listener: (payload: { id: string; res: boolean }) => void) => {
  dialogEventEmitter.off('check-id', listener);
};

const checkId = (id: string) => {
  const payload = { id, res: false };
  dialogEventEmitter.emit('check-id', payload);
  return payload.res;
};

export default {
  onAddDialog,
  offAddDialog,
  addDialog,
  onPopById,
  offPopById,
  popById,
  onCheckId,
  offCheckId,
  checkId,
};
